import {Navigate,useLocation} from 'react-router-dom';
import {canPage} from '../../components/ui/PermissionButton';
import {useAuth} from '../Context/AuthContext';

export default function ProtectedRoute({children,permission}){
 const auth=useAuth(),location=useLocation();
 if(auth?.loading)return <div className="min-h-screen flex items-center justify-center bg-black text-white">Checking access…</div>;
 if(!auth?.user)return <Navigate to="/stafflogin" replace/>;
 if(!canPage(auth,permission,location.pathname))return <Navigate to="/unauthorized" replace/>;
 return children;
}
